import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaWhatsapp, FaEnvelope, FaEdit} from "react-icons/fa";
import { Button } from "reactstrap";
import * as XLSX from "xlsx";
import "./FotoWisuda.css";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";


const API_URL = "https://graduation.rlagency.id/api/api-admin/get-foto-wisuda.php";

const FotoWisudaList = () => {
  const [fotoData, setFotoData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [isResumeOpen, setIsResumeOpen] = useState(false);
  const [resumeData, setResumeData] = useState({
    total: 0,
    duplicates: [],
    statusCounts: {},
  });

  const [sortNoUrutAsc, setSortNoUrutAsc] = useState(null); // null = tidak sort, true = ASC, false = DESC

  const toggleSortNoUrut = () => {
    // toggle antara null -> true -> false -> null (untuk 3 mode)
    if (sortNoUrutAsc === null) {
      setSortNoUrutAsc(true);
    } else if (sortNoUrutAsc === true) {
      setSortNoUrutAsc(false);
    } else {
      setSortNoUrutAsc(null);
    }
  };  

  // Filter states per kolom
  const [filterNama, setFilterNama] = useState("");
  const [filterNim, setFilterNim] = useState("");
  const [filterFakultas, setFilterFakultas] = useState("");
  const [filterProdi, setFilterProdi] = useState("");
  const [filterJenjang, setFilterJenjang] = useState("");
  const [filterTglWisuda, setFilterTglWisuda] = useState("");
  const [filterNoUrut, setFilterNoUrut] = useState(""); // Filter No Urut baru


  // Tambahkan di bagian state hooks (di atas useEffect atau di mana state kamu dideklarasi)
const [editModalOpen, setEditModalOpen] = React.useState(false);
const [editNoUrut, setEditNoUrut] = React.useState("");
const [editNim, setEditNim] = React.useState(null);
const [loadingUpdate, setLoadingUpdate] = React.useState(false);

// Fungsi buka modal edit nomor urut
const openEditModal = (nim, currentNoUrut) => {
  setEditNim(nim);
  setEditNoUrut(currentNoUrut);
  setEditModalOpen(true);
};

// Fungsi update nomor urut via API
const handleUpdateNoUrut = async () => {
  if (!editNoUrut || isNaN(editNoUrut)) {
    alert("Nomor urut harus berupa angka.");
    return;
  }

  setLoadingUpdate(true);
  try {
    const response = await axios.post(
      "https://graduation.rlagency.id/api/api-admin/update-nourut.php",
      {
        nim: editNim,
        urutWisuda: editNoUrut,
      }
    );

    if (response.data.status === "success") {
      alert("Nomor urut berhasil diperbarui.");
      setEditModalOpen(false);
      fetchFotoData(); // pastikan fungsi fetchFotoData() tetap ada di komponen lama untuk reload data
    } else {
      alert("Gagal memperbarui nomor urut.");
    }
  } catch (error) {
    console.error(error);
    alert("Terjadi kesalahan saat memperbarui nomor urut.");
  } finally {
    setLoadingUpdate(false);
  }
};


  useEffect(() => {
    fetchFotoData();
  }, []);

  const fetchFotoData = async () => {
    try {
      const response = await axios.get(API_URL);
      if (response.data.status === "success") {
        setFotoData(response.data.data);
      } else {
        setError("Gagal mengambil data.");
      }
    } catch (err) {
      console.error(err);
      setError("Terjadi kesalahan saat memuat data.");
    }
    setLoading(false);
  };

  // Filtering data sesuai filter kolom dan search term
  const filteredData = fotoData
    .filter((item) => {
      // Filter per kolom
      const matchNama = item.fullName.toLowerCase().includes(filterNama.toLowerCase());
      const matchNim = item.nim.toLowerCase().includes(filterNim.toLowerCase());
      const matchFakultas = item.faculty.toLowerCase().includes(filterFakultas.toLowerCase());
      const matchProdi = item.major.toLowerCase().includes(filterProdi.toLowerCase());
      const matchJenjang = item.degree.toLowerCase().includes(filterJenjang.toLowerCase());
      const matchTglWisuda = new Date(item.graduationPeriod)
        .toLocaleDateString("id-ID")
        .includes(filterTglWisuda);

      // Filter No Urut dengan string includes, konversi angka ke string juga
      const noUrutStr = String(item.urutWisuda);
      const matchNoUrut = noUrutStr.includes(filterNoUrut);

      return (
        matchNama &&
        matchNim &&
        matchFakultas &&
        matchProdi &&
        matchJenjang &&
        matchTglWisuda &&
        matchNoUrut
      );
    })
    .filter((item) => {
      // Filter search global
      const term = searchTerm.toLowerCase();
      const formattedDate = new Date(item.graduationPeriod).toLocaleDateString("id-ID");
      return (
        item.fullName.toLowerCase().includes(term) ||
        item.nim.toLowerCase().includes(term) ||
        item.faculty.toLowerCase().includes(term) ||
        item.major.toLowerCase().includes(term) ||
        formattedDate.includes(term)
      );
    });

    // Sorting berdasarkan No Urut
    if (sortNoUrutAsc !== null) {
      filteredData.sort((a, b) => {
        const urutA = parseInt(a.urutWisuda) || 0;
        const urutB = parseInt(b.urutWisuda) || 0;
        return sortNoUrutAsc ? urutA - urutB : urutB - urutA;
      });
    }

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data Wisuda");
    XLSX.writeFile(wb, "data_wisuda.xlsx");
  };

  const handleStatusUpdate = async (nim, field, value) => {
    try {
      const response = await axios.post(
        "https://graduation.rlagency.id/api/api-admin/update-status-wisuda.php",
        {
          nim,
          field,
          value,
        }
      );
      if (response.data.status === "success") {
        fetchFotoData();
      } else {
        alert("Gagal memperbarui status.");
      }
    } catch (err) {
      console.error(err);
      alert("Terjadi kesalahan saat memperbarui.");
    }
  };

  const generateResumeData = () => {
    const total = fotoData.length;

    const nameMap = {};
    fotoData.forEach((item) => {
      if (!nameMap[item.fullName]) {
        nameMap[item.fullName] = [];
      }
      nameMap[item.fullName].push(item);
    });
    const duplicates = Object.values(nameMap).filter((arr) => arr.length > 1);

    const statusCounts = {
      "Belum Lengkap": 0,
      "Foto Akan di Proses": 0,
      "Menunggu Pengiriman": 0,
      "Dikirim ke Mahasiswa": 0,
      "Selesai": 0,
    };

    fotoData.forEach((item) => {
      let status = "";
      if (item.daftar && item.pembayaran && item.verifikasi && !item.progress)
        status = "Foto Akan di Proses";
      else if (item.progress && !item.kirim) status = "Menunggu Pengiriman";
      else if (item.kirim && !item.selesai) status = "Dikirim ke Mahasiswa";
      else if (item.selesai) status = "Selesai";
      else status = "Belum Lengkap";

      statusCounts[status] = (statusCounts[status] || 0) + 1;
    });

    setResumeData({
      total,
      duplicates,
      statusCounts,
    });
    setIsResumeOpen(true);
  };

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedNim, setSelectedNim] = useState(null);

  const openConfirmModal = (nim) => {
    setSelectedNim(nim);
    setShowConfirmModal(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await axios.post(
        "https://graduation.rlagency.id/api/api-admin/detele-data-foto-wisuda.php",
        { nim: selectedNim }
      );

      if (response.data.status === "success") {
        toast.success("Data berhasil dihapus.");
        fetchFotoData();
      } else {
        toast.error("Gagal menghapus data.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Terjadi kesalahan saat menghapus data.");
    } finally {
      setShowConfirmModal(false);
      setSelectedNim(null);
    }
  };

  return (
    <div className="container">
      <h2>Data Foto Wisuda</h2>

      <div className="d-flex gap-2 mb-4 flex-wrap">
        <Button
          onClick={handleDownloadExcel}
          color="success"
          className="shadow-sm px-4 py-2 fw-semibold rounded-3"
          style={{ minWidth: "160px" }}
        >
          📥 Download Excel
        </Button>

        <Button
          onClick={generateResumeData}
          color="primary"
          className="shadow-sm px-4 py-2 fw-semibold rounded-3"
          style={{ minWidth: "160px" }}
        >
          📊 Resume Data
        </Button>
      </div>

      {loading ? (
        <p>Memuat data...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <>
          <div className="table-container table-responsive-wrapper">
            <table className="applicants-table-foto-wisuda">
              <thead>
                <tr>
                  <th>No</th>
                  <th>
                    Tgl Wisuda
                    <input
                      type="text"
                      className="form-control form-control-sm mt-1"
                      placeholder="Filter..."
                      value={filterTglWisuda}
                      onChange={(e) => setFilterTglWisuda(e.target.value)}
                    />
                  </th>
                  <th>
  No Urut
  <button
    type="button"
    className="btn btn-sm btn-light ms-2"
    onClick={toggleSortNoUrut}
    title="Urutkan"
  >
    {sortNoUrutAsc === null ? "↕️" : sortNoUrutAsc ? "⬆️" : "⬇️"}
  </button>
  <input
    type="text"
    className="form-control form-control-sm mt-1"
    placeholder="Filter..."
    value={filterNoUrut}
    onChange={(e) => setFilterNoUrut(e.target.value)}
  />
</th>

                  <th>
                    NIM
                    <input
                      type="text"
                      className="form-control form-control-sm mt-1"
                      placeholder="Filter..."
                      value={filterNim}
                      onChange={(e) => setFilterNim(e.target.value)}
                    />
                  </th>
                  <th>
                    Nama
                    <input
                      type="text"
                      className="form-control form-control-sm mt-1"
                      placeholder="Filter..."
                      value={filterNama}
                      onChange={(e) => setFilterNama(e.target.value)}
                    />
                  </th>
                  <th>
                    Fakultas
                    <input
                      type="text"
                      className="form-control form-control-sm mt-1"
                      placeholder="Filter..."
                      value={filterFakultas}
                      onChange={(e) => setFilterFakultas(e.target.value)}
                    />
                  </th>
                  <th>
                    Program Studi
                    <input
                      type="text"
                      className="form-control form-control-sm mt-1"
                      placeholder="Filter..."
                      value={filterProdi}
                      onChange={(e) => setFilterProdi(e.target.value)}
                    />
                  </th>
                  <th>
                    Jenjang
                    <input
                      type="text"
                      className="form-control form-control-sm mt-1"
                      placeholder="Filter..."
                      value={filterJenjang}
                      onChange={(e) => setFilterJenjang(e.target.value)}
                    />
                  </th>
                  <th>Email</th>
                  <th>Chat</th>
                  <th>Tanggal Daftar</th>
                  <th>Status Wisuda</th>
                  <th>Aksi</th>
                  <th>Hapus</th>
                </tr>
              </thead>

              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td colSpan="14" className="text-center text-muted py-4">
                      Tidak ada data yang sesuai filter.
                    </td>
                  </tr>
                ) : (
                  filteredData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>
                          {new Date(item.graduationPeriod).toLocaleDateString(
                            "id-ID"
                          )}
                        </td>
                        <td>
                          {item.urutWisuda}{" "}
                          <FaEdit
                            style={{ cursor: "pointer", marginLeft: 6 }}
                            color="#007bff"
                            title="Edit Nomor Urut"
                            onClick={() => openEditModal(item.nim, item.urutWisuda)}
                          />
                        </td>
                        <td>{item.nim}</td>
                        <td>{item.fullName}</td>
                        <td>{item.faculty}</td>
                        <td>{item.major}</td>
                        <td>{item.degree}</td>
                        <td>
                          <a href={`mailto:${item.email}`}>
                            <FaEnvelope size={14} color="#007bff" />
                          </a>
                        </td>
                        <td>
                          <a
                            className="whatsapp-link"
                            href={`https://wa.me/${
                              item.phone.startsWith("0")
                                ? "62" + item.phone.slice(1)
                                : item.phone
                            }`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaWhatsapp size={16} />
                          </a>
                        </td>
                        <td>
                          {new Date(item.created_at).toLocaleDateString("id-ID")}
                        </td>
                        <td>
                          {item.daftar &&
                          item.pembayaran &&
                          item.verifikasi &&
                          !item.progress
                            ? "Foto Akan di Proses"
                            : item.progress && !item.kirim
                            ? "Menunggu Pengiriman"
                            : item.kirim && !item.selesai
                            ? "Dikirim ke Mahasiswa"
                            : item.selesai
                            ? "Selesai"
                            : "Belum Lengkap"}
                        </td>
                        <td>
                          {item.daftar &&
                            item.pembayaran &&
                            item.verifikasi &&
                            !item.progress && (
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() =>
                                  handleStatusUpdate(item.nim, "progress", 1)
                                }
                              >
                                Proses Foto
                              </Button>
                            )}
                          {item.progress && !item.kirim ? (
                            <Button
                              size="sm"
                              color="warning"
                              onClick={() =>
                                handleStatusUpdate(item.nim, "kirim", 1)
                              }
                            >
                              Kirim Foto
                            </Button>
                          ) : null}
                          {item.kirim && !item.selesai ? (
                            <Button
                              size="sm"
                              color="success"
                              onClick={() =>
                                handleStatusUpdate(item.nim, "selesai", 1)
                              }
                            >
                              Tandai Selesai
                            </Button>
                          ) : null}
                        </td>
                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => openConfirmModal(item.nim)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Modal Resume Data */}
      <Modal
        isOpen={isResumeOpen}
        toggle={() => setIsResumeOpen(!isResumeOpen)}
        size="lg"
        centered
      >
        <ModalHeader toggle={() => setIsResumeOpen(false)}>
          Resume Data Foto Wisuda
        </ModalHeader>
        <ModalBody>
          <p>Total Data: {resumeData.total}</p>

          <h5>Data Duplikat (Nama Sama):</h5>
          {resumeData.duplicates.length === 0 ? (
            <p>Tidak ada data duplikat.</p>
          ) : (
            resumeData.duplicates.map((group, idx) => (
              <div key={idx}>
                <strong>{group[0].fullName}</strong>
                <ul>
                  {group.map((item) => (
                    <li key={item.nim}>
                      NIM: {item.nim}, Fakultas: {item.faculty}, Program Studi:{" "}
                      {item.major}
                    </li>
                  ))}
                </ul>
              </div>
            ))
          )}

          <h5>Statistik Status Foto Wisuda:</h5>
          <ul>
            {Object.entries(resumeData.statusCounts).map(([status, count]) => (
              <li key={status}>
                {status}: {count}
              </li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsResumeOpen(false)}>
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Konfirmasi Hapus */}
      <Modal
        isOpen={showConfirmModal}
        toggle={() => setShowConfirmModal(false)}
        centered
      >
        <ModalHeader toggle={() => setShowConfirmModal(false)}>
          Konfirmasi Hapus Data
        </ModalHeader>
        <ModalBody>
          Apakah Anda yakin ingin menghapus data dengan NIM {selectedNim}?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>
            Hapus
          </Button>
          <Button color="secondary" onClick={() => setShowConfirmModal(false)}>
            Batal
          </Button>
        </ModalFooter>
      </Modal>


      <Modal
  isOpen={editModalOpen}
  toggle={() => setEditModalOpen(!editModalOpen)}
  centered
>
  <ModalHeader toggle={() => setEditModalOpen(false)}>
    Edit Nomor Urut
  </ModalHeader>
  <ModalBody>
    <div>
      <label>Nomor Urut Baru:</label>
      <input
        type="number"
        className="form-control"
        value={editNoUrut}
        onChange={(e) => setEditNoUrut(e.target.value)}
        min="1"
      />
    </div>
  </ModalBody>
  <ModalFooter>
    <Button
      color="primary"
      onClick={handleUpdateNoUrut}
      disabled={loadingUpdate}
    >
      {loadingUpdate ? "Menyimpan..." : "Simpan"}
    </Button>
    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
      Batal
    </Button>
  </ModalFooter>
</Modal>

    </div>
  );
};

export default FotoWisudaList;
